import { api } from 'common';

const { DurationUnits } = api.FlowDefinition;

export function getDefaultServiceReviewConfig() {
  return {
    submissionMode: '',
    payorPortal: '',
    patientInsuranceId: '',
    patientOrder: '',
    customPayload: '',
    fileReference: '',
    caseId: '',
    description: '',
    timeout: {
      value: 1,
      units: DurationUnits.Hours,
    },
    isTest: true,
  };
}
